"use client";
import { jsx } from "react/jsx-runtime";
import { Dialog } from "@base-ui/react/dialog";
import { Drawer } from "@base-ui/react/drawer";
import { forwardRef } from "react";
import { cn } from "../../utils/cn.js";
import { dialogVariants } from "./Dialog.variants.js";
import { useDialogMode } from "./DialogContext.js";
const { title: title } = dialogVariants();
const DialogTitle_DialogTitle = /*#__PURE__*/ forwardRef(function({ className, slots, ...props }, ref) {
    const mode = useDialogMode();
    const classes = cn(title(), className, slots?.title);
    if ('drawer' === mode) return /*#__PURE__*/ jsx(Drawer.Title, {
        ref: ref,
        className: classes,
        ...props
    });
    return /*#__PURE__*/ jsx(Dialog.Title, {
        ref: ref,
        className: classes,
        ...props
    });
});
export { DialogTitle_DialogTitle as DialogTitle };
